<template>
  <section class="summary" id="summary">
    <div class="container">
      <div class="row mx-auto title fade-in">
        <div class="col-12 text-center">
          <h1>Kontakt & Anfahrt</h1>
          <p class="textbox text-center">Wir freuen uns auf Sie.</p></div>
      </div>
    </div>
    <div class="container">
      <div class="row mx-auto">
        <div class="col-12 col-lg-6 slide-in from-left">
          <div class="textbox text-left notification">
            <p>Bei Haarlem versuchen wir die Bedürfnisse jedes Kunden zu erfüllen und bereiten uns deswegen auf jeden
              Kunden individuell vor. Falls Sie mal einen Termin nicht wahrnehmen können, bitten wir Sie darum, uns 24h
              vorher abzusagen.</p>
            <p class="location"><a
                href="https://www.google.com/maps/place/Haarlem+Friseure/@53.5716198,10.0675617,17z/data=!3m1!4b1!4m5!3m4!1s0x47b18c003052ed07:0x78fc0ed1a836b525!8m2!3d53.5716166!4d10.0697504"
                target="_blank">Schloßstr. 44, 22041 Hamburg</a></p>
            <p class="mail"><a href="mailto:info@haarlem-friseure.de">info@haarlem-friseure.de</a></p>
            <p class="telephone"><a href="tel:+494051906895">(040) 51 90 68 95</a></p>
            <a href="https://salonkee.de/salon/haarlem-friseure"
               class="btn btn-primary mt-4"
               target="_blank"
               rel="noopener">
              Jetzt Termin buchen
            </a>
          </div>
        </div>
        <div class="col-12 col-lg-6 slide-in from-right">
          <a href="https://www.google.com/maps/place/Haarlem+Friseure/@53.5716198,10.0675617,17z/data=!3m1!4b1!4m5!3m4!1s0x47b18c003052ed07:0x78fc0ed1a836b525!8m2!3d53.5716166!4d10.0697504"
             target="_blank"><img src="../../../assets/images/haarlem_shop_map.svg" alt=""></a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Summary"
}
</script>

<style scoped lang="scss">
@import 'src/assets/scss/imports';

.summary {
  h1 {
    text-transform: uppercase;
    letter-spacing: 4px;
  }

  .title {
    margin-bottom: 35px;
  }

  .notification:before {
    content: '';
    display: inline-block;
    vertical-align: middle;
    background-repeat: no-repeat;
    background-size: contain;
    margin: 6px 5px 10px 0px;
    height: 45px;
    width: 45px;
    background-image: url("../../../assets/images/notification.svg");
  }

  .location:before, .mail:before, .telephone:before {
    content: '';
    display: inline-block;
    vertical-align: middle;
    background-repeat: no-repeat;
    background-size: contain;
    margin-right: 5px;
    height: 25px;
    width: 25px;
  }

  .location:before {
    background-image: url("../../../assets/images/location_black.svg");
  }

  .mail:before {
    margin-top: 5px;
    background-image: url("../../../assets/images/mail.svg");
  }

  .telephone:before {
    background-image: url("../../../assets/images/phone.svg");
  }

  .btn {
    &:hover {
      color: white;
    }
  }
}
</style>
